import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { LanguageSelect } from "../../components/LanguageSelect/LanguageSelect";
import { routes } from "../../routes/routes";
import { RootState } from "../../store/store";
import {
  getVersionPageStyle,
  getVersionPageTextColor,
  getVersionReturnPath,
  versionDetailPath,
  VersionLocationState,
} from "./versionPageUtils";

type VersionPageShellProps = {
  onBack: () => void;
  children: ReactNode;
};

export const VersionPageShell = ({ onBack, children }: VersionPageShellProps) => {
  const { t } = useTranslation();
  const user = useSelector((state: RootState) => state.user.user);
  const isLoggedIn = !!user && user.id !== 0;
  const pageTextColor = getVersionPageTextColor();

  return (
    <div className="version-page" style={getVersionPageStyle()}>
      <div className="version-page__toolbar">
        <button type="button" className="version-page__back" onClick={onBack}>
          ← {t("version_page.back_button")}
        </button>
        <LanguageSelect color={pageTextColor} withUserUpdate={isLoggedIn} />
      </div>
      {children}
    </div>
  );
};

export const useVersionNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state: RootState) => state.user.user);
  const versionState = (location.state as VersionLocationState | null) ?? {};

  const backToList = () => {
    navigate(routes.VERSION, { state: versionState, replace: true });
  };

  const exitToApp = () => {
    navigate(getVersionReturnPath(versionState, user));
  };

  const goToDetail = (version: string) => {
    navigate(versionDetailPath(version), { state: versionState });
  };

  return { backToList, exitToApp, goToDetail };
};
